import Vue from 'vue'
import Vuex from 'vuex'

import UserModule from "@/inside/stores/user";
import TextsModule from "@/inside/stores/texts";
import FiltersModule from "@/inside/stores/filters";
import ActionsModule from "@/inside/stores/actions";
import ThematicsModule from "@/inside/stores/thematics";
import DashboardModule from "@/inside/stores/dashboard";
import NGFiltersModule from "@/inside/stores/ngfilters";
import AssignmentsModule from "@/inside/stores/assignments";
import PermissionsModule from "@/inside/stores/permissions";
import NotificationsModule from "@/inside/stores/notifications";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        drawer: {
            open:false,
            mode: null
        },
        openInformations: false,
        watchLayout: "split",
        overlayVisible: false
    },
    mutations: {
        /**
         *
         * @param {Object} state
         * @param {Object} payload
         */
        toggleDrawer(state, payload) {
            state.drawer.open = (payload.open !== undefined ? Boolean(payload.open) : !state.drawer.open);
            state.overlayVisible = state.drawer.open;
            state.drawer.mode = payload.mode;
        },
        toggleInformation(state, force){
            state.openInformations = (force !== undefined ? Boolean(force) : !state.openInformations)
        },
        /**
         * Toggles Watch page layout, between 'split' and 'full-list'.
         *
         * @param {object} state
         */
        toggleWatchLayout(state) {
            state.watchLayout = (state.watchLayout === 'split' ? 'full-list' : 'split');
        },
        /**
         * Toggles app overlay, under filter drawer and modals.
         *
         * @param {object} state
         * @param {Boolean} force
         */
        toggleOverlay(state, force) {
            state.overlayVisible = (force !== undefined ? Boolean(force) : !state.overlayVisible)
        }
    },
    getters: {
        watchLayout(state) {
            return state.watchLayout;
        }
    },
    modules: {
        texts: TextsModule,
        user: UserModule,
        filters: FiltersModule,
        actions: ActionsModule,
        assignments: AssignmentsModule,
        notifications: NotificationsModule,
        dashboard: DashboardModule,
        permissions: PermissionsModule,
        thematics: ThematicsModule,
        ngFilters: NGFiltersModule
    }
});
